import { observable, toJS } from "mobx";
import { buscaSemResultado } from "../utils/mensagens";

export default class DataStore {

    static defaultProps = { value: null, loading: false, error: "" };

    defaultObj(defaultValue) {
        return observable({ ...DataStore.defaultProps, value: defaultValue, defaultValue });
    }

    getProperty = (prop) => typeof prop == 'string' && this.hasOwnProperty(prop) ? this[prop] : prop;

    set(property, value, { overwrite = true } = {}) {
        let prevRef;
        
        property = this.getProperty(property);
        
        prevRef = toJS(property);
        
        if (typeof value == 'function') value = value(prevRef);
        
        if (typeof value != 'object' || !Object.keys(value).some(k => Object.keys(DataStore.defaultProps).includes(k))) value = { value };

        for (const key in prevRef) {
            if (Object.hasOwnProperty.call(value, key)) {
                property[key] = value[key];
            } else if (overwrite && Object.hasOwnProperty.call(DataStore.defaultProps, key)) {
                if (key == 'value' && Object.hasOwnProperty.call(prevRef, 'defaultValue')) {
                    property.value = prevRef.defaultValue;
                } else {
                    property[key] = DataStore.defaultProps[key];
                }
            }
        }
    }

    setValue(property, value, options) {
        let prevRef;
        
        property = this.getProperty(property);
        
        prevRef = toJS(property);
        
        if (typeof value == 'function') value = value(prevRef.value);

        this.set(property, { value }, options);
    }

    setLoading(property, newValue = true) {
        property = this.getProperty(property);

        if (Object.hasOwnProperty.call(property, 'loading'))
            property.loading = newValue;
    }

    setError(property, newValue = '') {
        property = this.getProperty(property);

        if (Object.hasOwnProperty.call(property, 'error'))
            property.error = newValue;
    }

    fetchAndSetData = async (property, getFunction, ...getArgs) => {
        this.setLoading(property);

        const data = await this.fetchData(property, getFunction, ...getArgs);

        if(typeof data != 'undefined') this.set(property, data);

        this.setLoading(property, false);
    }

    fetchData = async (property, getFunction, ...getArgs) => {
        property = this.getProperty(property);

        try {
            const { status, data } = await Promise.resolve(getFunction(...getArgs));

            switch (status) {
                case 200:
                    return data;
                case 400:
                    this.set(property, { error: data.Message || "Ocorreu um erro ao buscar os dados!" });
                    break;
                case 404:
                    this.set(property, { error: buscaSemResultado });
                    break;
                default: break;
            }
        } catch (error) {
            this.set(property, { error: "Ocorreu um erro inesperado ao buscar os dados!" });
            throw error;
        } finally {
            //this.setLoading(property, false);
        }
    }
}


// WEBPACK FOOTER //
// ./src/stores/DataStore.js